module.exports = __webpack_public_path__ + "static/threat-min-412402d2c1d7a8603ca1b64f2d02faca.jpg";